import { createContext } from 'react';

import { Language } from '@/shared/config';

interface LanguageContextType {
  lang: Language;
  changeLang: (lang: Language) => void;
}

export const LanguageContext = createContext<LanguageContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  changeLang: () => {},
  lang: Language.Russian,
});
